import React, { PropsWithChildren } from "react";
import {CssBaseline, makeStyles, Theme} from '@material-ui/core';
import PageHeader from "./common/PageHeader";
import PageFooter from "./common/PageFooter";

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        display: 'flex',
        flex: 1,
        flexDirection: "column"
    },
    content: {
        flexGrow: 1,
        marginBottom: 50
    },
}));

type AuthenticatedUserLayoutProps = {
    pageTitle?: string
};

export const PublicTrackingLayout: React.FC<PropsWithChildren<AuthenticatedUserLayoutProps>> = ({pageTitle, children}) => {

    const classes = useStyles();


    return (<div className={classes.root}>
            <CssBaseline/>
            <PageHeader pageTitle={pageTitle}/>

            <main
                className={classes.content}
            >

                {children}

            </main>

            <PageFooter/>
        </div>
    );


};

export default PublicTrackingLayout;
